module.exports = "<pre><code class=\"hljs js\"><span class=hljs-keyword>import</span> {FocusTrap} <span class=hljs-keyword>from</span> <span class=hljs-string>'wovue-focus-trap'</span>\n\n<span class=hljs-keyword>export</span> <span class=hljs-keyword>default</span> {\n  <span class=hljs-comment>// ...</span>\n  components: {\n    FocusTrap\n  }\n  <span class=hljs-comment>// ...</span>\n}\n</code></pre> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/installation-commonjs-alternative.md
 ** module id = 71
 ** module chunks = 1
 **/